import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {
  Button,
  Icon,
  Input,
  Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import { object as yupObject } from 'yup';
import Auth from '@aws-amplify/auth';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import { emailValidation } from '../../../modules/validation/User';

const validationSchema = yupObject().shape({
  email: emailValidation,
});

class ForgotForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { email } = props;

    this.state = {
      email,
      error: '',
    };
  }

  storeEmail = async (email) => {
    try {
      await AsyncStorage.setItem('email', email);
    } catch (error) {
      // Error saving data
    }
  };

  // TODO(clairbee): move auth to 'Forgot.js'; keep only UI stuff here
  onSubmit = (values, formikBag) => {
    const { history, redirect } = this.props;
    let { email } = values;

    email = email.trim();

    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    // FIXME(clairbee): move all 'meat' to the 'Forgot' class
    Auth.forgotPassword(email)
      .then((_data) => {
        this.storeEmail(email)
          .then(() => {
            history.push(`/forgotsubmit${redirect}`);
          })
          .catch(() => null);
      })
      .catch((err) => {
        console.log(err);
        let error = err.message || '';
        if (err.code === 'LimitExceededException') {
          error = translate('signin_error_limit');
        }
        this.setState({ email, error });
        formikBag.setSubmitting(false);
        formikBag.errorMessage(error);
      });
  };

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
  }) => {
    const { history } = this.props;
    const { error } = this.state;

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      >
        <Header
          name={translate('forgot_header')}
          hasCancel
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={{
            width: '100%',
            padding: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
            paddingBottom: 20,
          }}
        >
          {error !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {error}
            </Text>
          )}

          <Input
            label={translate('signin_email')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.email && errors.email ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            value={values.email}
            placeholder={translate('signin_email_placeholder')}
            autoCompleteType="email"
            textContentType="emailAddress"
            importantForAutofill="yes"
            leftIcon={(
              <Icon
                name="user"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            keyboardType="email-address"
            autoCapitalize="none"
            autoFocus
            onChangeText={(value) => setFieldValue('email', value)}
            onBlur={() => setFieldTouched('email')}
            editable={!isSubmitting}
            errorMessage={touched.email && errors.email ? errors.email : undefined}
          />

          <Button
            title={translate('forgot_action')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.buttonfsf.primary}
            disabledStyle={styles.buttonfsf.primaryDisabled}
            titleStyle={styles.buttonfsf.primaryTitle}
            disabledTitleStyle={styles.buttonfsf.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
          {/* <Button
            clear
            title={translate('button_cancel')}
            containerStyle={[styles.buttonfsf.secondaryContainer, { marginTop: 20 }]}
            buttonStyle={styles.buttonfsf.secondary}
            titleStyle={styles.buttonfsf.secondaryTitle}
            onPress={() => history.push('/ai-agents')}
          /> */}
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  }

  render() {
    const { error, email } = this.state;
    return (
      <Formik
        enableReinitialize
        initialValues={{ email, error }}
        onSubmit={this.onSubmit}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

ForgotForm.defaultProps = {
  redirect: '/',
};

ForgotForm.propTypes = {
  redirect: PropTypes.string,
  email: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default ForgotForm;
